import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../consts/routes';
import { useAdminCardDecks } from '@olagg/api-hooks';
import CardDeckForm from './Form';
import { CreateCardDeckData } from '@olagg/db-types';
import { VStack } from '@chakra-ui/react';
import { Heading } from '@chakra-ui/react';
import { Center } from '@chakra-ui/react';

export const CreateCardDeck: FC = () => {
  const navigate = useNavigate();
  const { createCardDeck } = useAdminCardDecks();

  const handleSubmit = async (data: CreateCardDeckData) => {
    await createCardDeck(data);
    navigate(ROUTES.CARD_DECKS.all);
  };

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>
          Crear Mazo de Cartas
        </Heading>
        <CardDeckForm onSubmit={handleSubmit} />
      </VStack>
    </Center>
  );
};
